import { api } from "../../util";

export const getAccountsApiCall = (payload = {}) => {
  let url = "/accounts";

  return api.get(url, {
    params: {
      page: payload.page,
      limit: payload.limit,
      filter: payload.filter || {},
      sort: payload.sort,
      //   search: payload.search,
    },
  });
};
